import React from "react";
import mwhLogo from "../../assets/images/MWHLogo.png";
import { VIEWER_PAGE } from "../../helpers/constants/Constants";

const homeRedirect = VIEWER_PAGE;

const NotFound = () => {
  return (
    <div className="accessDeniedComp">
      <div className="accessDeniedCard">
        <div className="titleSpace">
          <h1>SORRY</h1>
        </div>
        <div className="paraSpace">
          <p>This is an incorrect URL</p>
        </div>
        <div className="buttonSpace">
          <a href={homeRedirect}>
            <button className="bttn">Return to home page.</button>
          </a>
        </div>
        <div className="logoSpace">
          <img src={mwhLogo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
